import { AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { ForecastService } from "src/app/services/forecast.service";
import { TasDataSource } from "src/app/services/tasGovTable.datasource";
import { CategoryService } from "src/app/services/category.service";
import { merge } from "rxjs";
import { tap } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { ProcessService } from "src/app/services/process.service";
import { TaxPayerService } from "src/app/services/taxPayer.service";
@Component({
  selector: "app-forecast-table",
  templateUrl: "./forecast-table.component.html",
  styleUrls: ["./forecast-table.component.css"],
})
export class ForecastTableComponent implements OnInit, AfterViewInit {
  singleMunicipality
  dataSource: TasDataSource;
  displayedColumns: string[] = ["revenueCode", "revenueCodeName", "fees"];
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  filterObject = {};
  @Input() currentYear = new Date().getFullYear().toString();
  @Input() municipality;
  filterData = { municipality: null };
  currentUser
  selectedData
  forecastState
  approvedForecast = false
  loading = { inProgress: false, downloadInProgress: false, downloadAttachmentInProgress: false }
  constructor(
    private forecastService: ForecastService,
    public categoryService: CategoryService,
    public translate: TranslateService,
    public processService: ProcessService,
    private taxPayerService: TaxPayerService,
    
  ) { }

  async ngOnInit() {
    this.dataSource = new TasDataSource(this.forecastService);
    try {
      this.currentUser = await this.taxPayerService.getTaxPayer('tax-payers').toPromise();
      if (this.currentUser.municipality.id) {
        const municipalityId = this.currentUser.municipality.id;
        this.filterObject['municipality'] = [municipalityId];
  
        this.categoryService.getList("municipality").subscribe((result) => {
          this.filterData["municipality"] = result.map(fld => ({
            name: fld.name,
            id: fld.id,
          }));
  
          this.selectedData = this.filterData["municipality"].find(elem => elem.id === municipalityId);
          if (this.selectedData) {
            this.singleMunicipality = this.selectedData.name;
          }
        });
  
        this.loadTable();
      }
  
    } catch (error) {
      console.error("Failed to load current user:", error);
    }
  }
  

  externalFunction() {
    this.dataSource.emptyData()
    this.loadTable();
  }
  async loadTable() {
    this.filterObject["year"] = this.currentYear + '';
    if (!this.filterObject["municipality"]) this.dataSource.emptyData();
    this.forecastState = await this.forecastService.getForecastState(this.currentYear, this.filterObject['municipality'][0]).toPromise()
    if ((!this.forecastState || this.forecastState.state !== 'APPROVED') ) {
      this.approvedForecast = true
      this.dataSource.emptyData();
    }
    else {
      this.approvedForecast = false
      this.loading.inProgress = true
      this.dataSource.emptyData()
      this.dataSource.loadData(
        "forecast/dialoglist",
        "",
        this.sort.direction,
        this.sort.active,
        this.paginator.pageIndex,
        this.paginator.pageSize,
        this.filterObject,
        this.loading
      );
    }
  }

  ngAfterViewInit() {

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadTable())
      ).subscribe();
  }
  getTotalSum(key) {
    if (this.dataSource)
      return this.dataSource.getTotalSum(key)
  }
  selectChange = (event: any, field) => {
    this.filterObject[field] = event.data.map((elem) => elem.id);
    if (this.filterObject[field].length === 0) {
      delete this.filterObject[field];
      this.dataSource.clearTotalSums()
    }
    this.loadTable();
  };

  getFeeAmount(fee){
    let amount = isNaN(fee.amount) ? 0 : fee.amount * 1
    if (fee.type==='AMOUNT')
      return amount.toLocaleString('fr-FR')
    return amount+'%'
  }
}
